interface ExpenseReportItem {
  amount: string
  taxMode: 'percent' | 'dollar' | 'saved'
  taxValue: string
  reimbursable: boolean
}

interface ComputeExpenseReportTotalsInput {
  items: readonly ExpenseReportItem[]
}

interface ComputeExpenseReportTotalsOutput {
  totalAmount: number
  totalTax: number
  subtotal: number
  reimbursableTotal: number
}

export class ComputeExpenseReportTotalsUseCase {
  execute(
    input: ComputeExpenseReportTotalsInput
  ): ComputeExpenseReportTotalsOutput {
    const { items } = input

    const totalAmount = items.reduce(
      (sum, item) => sum + Number.parseFloat(item.amount || '0'),
      0
    )

    const totalTax = items.reduce((sum, item) => {
      const total = Number.parseFloat(item.amount || '0')
      const taxValue = Number.parseFloat(item.taxValue || '0')

      if (item.taxMode === 'percent') {
        const rate = taxValue / 100
        if (rate <= 0) return sum
        const itemSubtotal = total / (1 + rate)
        return sum + (total - itemSubtotal)
      }
      if (item.taxMode === 'dollar' || item.taxMode === 'saved') {
        return sum + taxValue
      }
      return sum
    }, 0)

    const subtotal = totalAmount - totalTax

    const reimbursableTotal = items
      .filter((item) => item.reimbursable)
      .reduce((sum, item) => sum + Number.parseFloat(item.amount || '0'), 0)

    return { totalAmount, totalTax, subtotal, reimbursableTotal }
  }
}
